import { useRef } from 'react';
import AboutPage from './components/pages/AboutPage';
import SkillsPage from './components/pages/SkillsPage';
import ExperiencePage from './components/pages/ExperiencePage';
import CommunityEngagementPage from './components/pages/CommunityEngagementPage';
import ContactPage from './components/pages/ContactPage';

const useNodesData = () => [
    {
        id: 'intro',
        ref: useRef(null),
        content: 'Gillian Bryson',
        modalContent: {
            title: 'About Gillian Bryson',
            body: <AboutPage />
        },
        gridArea: {
            desktop: '2 / 2',
            mobile: '1 / 2'
        }
    },
    {
        id: 'skills',
        ref: useRef(null),
        content: 'Skills',
        modalContent: {
            title: 'Technical Skills',
            body: <SkillsPage />
        },
        gridArea: {
            desktop: '1 / 4',
            mobile: '2 / 1'
        }
    },
    {
        id: 'experience',
        ref: useRef(null),
        content: 'Experience',
        modalContent: {
            title: 'Work Experience',
            body: <ExperiencePage />
        },
        gridArea: {
            desktop: '3 / 5',
            mobile: '4 / 3'
        }
    },
    {
        id: 'community engagement',
        ref: useRef(null),
        content: 'Community Engagement',
        modalContent: {
            title: 'Community Engagement',
            body: <CommunityEngagementPage />
        },
        gridArea: {
            desktop: '2 / 6',
            mobile: '3 / 2'
        }
    },
    {
        id: 'contact',
        ref: useRef(null),
        content: 'Contact',
        modalContent: {
            title: 'Get In Touch',
            body: <ContactPage />
        },
        gridArea: {
            desktop: '2 / 9',
            mobile: '5 / 2'
        }
    }
];

const connections = [
    { from: 'intro', to: 'skills' },
    { from: 'intro', to: 'experience' },
    { from: 'intro', to: 'community engagement' },
    { from: 'community engagement', to: 'contact' },
    { from: 'skills', to: 'contact' },
    { from: 'experience', to: 'contact' },
];

export { useNodesData, connections };